<template>
    <div class="modal">
        <transition name="modal-transition">
            <div v-if="isVisible" class="modal__wrap" @click="close">

                <div class="modal__container" @click="$event.stopPropagation()"
                    :class="{'modal__container--image': component == 'ImageContainer'}">

                    <div class="modal__content-wrap scrollable">
                        <a href="#" @click.prevent="close" class="modal__button-close" >x</a>

                        <div class="modal__content">
                            <slot>
                                <component :is="component" @close="close" :inModal="true" v-bind="data" ref="content"></component>
                            </slot>
                        </div>

                    </div>

                    <div class="modal__footer" id="modal__footer">
                    </div>

                </div>

            </div>
        </transition>
    </div>
</template>


<script>

import Glossary from 'js/components/elements/Glossary.vue'
import Goals from 'js/components/elements/Goals.vue'
import ImageContainer from 'js/components/elements/Image.vue'
import Teachertips from 'js/components/elements/Teachertips.vue'
import Reflectiontips from 'js/components/elements/Reflectiontips.vue'
import Term from 'js/components/elements/Term.vue'
import SchoolGroups from 'js/components/groups/School.vue'
import Settings from 'js/components/settings/Settings.vue'
import GroupSettings from 'js/components/groups/settings/Settings.vue'
import GroupArchived from 'js/components/groups/settings/Archived.vue'
import ReflectionPartial from 'js/components/assignment/partials/ReflectionPartial.vue'
import Legal from 'js/components/auth/Legal.vue'

import ImageUpload from 'js/components/elements/ImageUpload.vue'

export default {
    props: {
        show: {
            type: Boolean,
            default: true,
        }
    },

    components: { Glossary, Goals, Term, ImageContainer, Teachertips, Reflectiontips, ReflectionPartial, SchoolGroups, Settings, GroupSettings, GroupArchived, ImageUpload, Legal },

    vuex: {
        getters: {
            component: state => state.modal.component,
            isDirty: state => state.modal.isDirty,
            data: state => state.modal.data || {},
        },
        actions: {
            closeModal: ({dispatch}) => {
                dispatch('HIDE_MODAL')
                dispatch('MODAL_CLEAN')
            }
        }
    },

    methods: {
        close: function() {
            const continueClosing = () => {
                this.closeModal()
                this.$emit('close')
            }

            if ( !this.isDirty ) {
                return continueClosing()
            }

            if ( !this.$refs.content.confirmDirty ) {
                console.error('Modal content can\'t confirm dirty')
                return continueClosing()
            }

            this.$refs.content.confirmDirty()
                .then(
                    () => continueClosing(),
                    () => { }
                )
        }
    },

    computed: {
        isVisible: function() {
            return this.show && ( !!this.component || this.$slots.default )
        }
    }
}
</script>


<style lang="scss">

    @import 'global';

    .modal {
        &__wrap {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: $z-index-modal;
            background-color: transparentize($color-black, 0.7);
            backdrop-filter: blur(10px);
            padding: 4% 0;
            -webkit-tap-highlight-color: rgba(0,0,0,0);
        }

        &__container {
            width: 600px;
            max-width: 90%;
            min-height: 10em;
            max-height: 100%;

            margin: 0 auto;

            display: flex;
            flex-direction: column;
            position: relative;

            background: $color-white;
            border-radius: 4px;
            box-shadow: 0 6px 15px rgba(0,0,0,0.2);

            * {
                -webkit-tap-highlight-color: initial;
            }

            &--image {
                width: 750px;
                .modal__button-close {
                    display: none;
                }
            }


            .page-header {
                margin-bottom: 1em;
                h1 {
                    margin-top: 0;
                }
            }

        }

        &__button-close {
            position: absolute;
            top: 8px;
            right: 12px;
            text-align: center;
            text-decoration: none;
            font-size: 1.1em;
            width: 2em;
            height: 2em;
            display: block;
        }

        &__content {

            > div {
                margin: 12%;
                @include clearfix();
            }

            > .full-width {
                margin: 0;
                img {
                    margin: 1em auto;
                    width: auto;
                    max-width: 100%;
                }
            }

            > .tight {
                margin: 6%;
            }

            > .includes-header {
                margin: 6% 12%;
            }

            img {
                margin: 1em -10%;
                width: 120%;
                display: block;
            }

        }

        &__content-wrap {
            overflow-y: auto;
            flex-shrink: 1;
            flex-grow: 1;
        }

        &__footer {
            border-top: 1px solid $color-superlight-grey;
            padding: 0 20px;
            text-align: right;

            flex-shrink: 0;
            flex-grow: 0;

            &:empty {
                border: none;
            }
        }

        &__test {
            display: flex;
            flex-direction: row;
        }

    }

    // IE11 only hack
    // Unfortunately flex-shrink of content does not work when parent has no specified height
    // So content overflows on IE11, this hack prevents the overflow, but drawback is that the footer scrolls out of view.
    @media all and (-ms-high-contrast:none) {
        *::-ms-backdrop, .modal__container {
            overflow-y: auto;
        }
    }


</style>



// WEBPACK FOOTER //
// Modal.vue?05aa8209